import { buildLinkToken, buildMentionToken, escapeCommentText } from "@nova/schemas"

export const TOKEN_ATTR = "data-mention-user-id"
export const LINK_TOKEN_ATTR = "data-link-url"

const BLOCK_TAGS = new Set(["DIV", "P", "LI", "TR", "BLOCKQUOTE", "PRE", "H1", "H2", "H3"])

const serializeNode = (node: Node): string => {
    if (node.nodeType === Node.TEXT_NODE) {
        return escapeCommentText(node.textContent ?? "")
    }
    if (!(node instanceof HTMLElement)) return ""

    const userId = node.getAttribute(TOKEN_ATTR)
    if (userId) return buildMentionToken(userId)

    const linkUrl = node.getAttribute(LINK_TOKEN_ATTR)
    if (linkUrl) {
        const label = node.textContent ?? ""
        return label ? buildLinkToken(escapeCommentText(label), linkUrl) : ""
    }

    if (node.tagName === "BR") return "\n"

    const inner = [...node.childNodes].map(serializeNode).join("")
    return BLOCK_TAGS.has(node.tagName) ? `${inner}\n` : inner
}

export const serializeEditor = (root: HTMLElement): string =>
    [...root.childNodes].map(serializeNode).join("").replace(/\n+$/, "")
